import { TicketRepository } from '../repositories/TicketRepository'

export function DeleteAreaIdCase(ticketRepository: TicketRepository) {
  return async function ({ areaId }) {
    return await ticketRepository.deleteAreaId({ areaId })
  }
}
